export const COLUMNS_DESKTOP = 4;
export const COLUMNS_MOBILE = 3;

// Global "Loan Origination Company" contact type (SkynetCore GlobalContactTypeIds): a company with no person
// name, kept on loans imported from another LOS.
export const LOAN_ORIGINATION_COMPANY_CONTACT_TYPE_ID = '6b0f2c1e-3d4a-4f7e-9a51-2c8e7d1b4a02';

// Loan-contacts view fields the edit drawer's contact navigation reads.
export const ContactsField = {
  TYPE: 'contactTypeName',
  NAME: 'fullName',
  COMPANY: 'companyName',
};
